/**
 * Quick Action Card
 *
 * Shows a stat with icon, count, and optional action.
 * Used in the Study Dashboard for quick navigation to different recommendation categories.
 */

import { Card, CardContent } from "@/components/ui/card";

interface QuickActionCardProps {
  emoji: string;
  title: string;
  count: number;
  subtitle: string;
  onClick?: () => void;
}

export function QuickActionCard({
  emoji,
  title,
  count,
  subtitle,
  onClick,
}: QuickActionCardProps) {
  return (
    <Card
      className={`border border-border/70 bg-white/80 shadow-lg shadow-primary/10 backdrop-blur dark:bg-secondary/70 ${
        onClick ? "cursor-pointer hover:shadow-xl hover:scale-105 transition-all" : ""
      }`}
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex items-center gap-4">
          <div className="text-4xl">{emoji}</div>
          <div className="flex-1">
            <div className="text-3xl font-bold">{count}</div>
            <div className="text-sm font-medium text-muted-foreground">
              {title}
            </div>
            <div className="text-xs text-muted-foreground mt-0.5">
              {subtitle}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
